<!-- 
程式：RelationInfo.vue
功能：相關保單資訊
作者：i9400539 鄧啓擇
完成：2020-07-30
-->
<template>
  <main>
    <section class="search container" style="padding: 30px 0">
      <div class="container-fluid">
        <div class="row">
          <div class="col-10">
            <h6>
              與 <truncate-tool :content="reqName"></truncate-tool>
              相關的要保人、被保人
            </h6>
          </div>
          <div class="col-2 text-right" style="padding: 5px 0px 0px">
            <a
              @click="goBackJoinFamily()"
              type="button"
              class="btn btn-default float-right"
              style="width: 130px; height: 40px; margin: 10px 0px"
            >
              返回上一頁
            </a>
          </div>

          <!-- kerry test -->
          <user-data-table
            style="width: 78rem; padding: 0px"
            @update="updateSelection"
            @updateall="updateSelectAll"
            :selection="selection"
            :table-data="userList"
            :options="tableOption.user"
            :remote-data-msg="remoteDataMsg"
          />
        </div>
      </div>
    </section>
    <section
      class="search container"
      style="padding: 20px 0; margin-bottom: 130px"
    >
      <!-- 與tableTitle相關的保單（僅顯示您的經手件及服務件）-->
      <data-table
        :tableTitle="`${reqName}`"
        :checkTableTitle="checkTableTitle"
        :table-data="policyList"
        :options="tableOption.policy"
        ><template slot="policy_no"
          ><span
            data-v-d0da097e=""
            class="text-gray"
            style="text-shadow: grey 0px 1px"
            ><strong data-v-d0da097e="">└</strong></span
          ></template
        ></data-table
      >
    </section>
    <fixed-botton>
      <template slot="@function">
        <button
          @click="sumbit()"
          type="button"
          class="btn btn-primary bottom_btn_style"
          :disabled="!selection.length"
        >
          歸戶
        </button>
      </template>
    </fixed-botton>
    <mv-add-family-modal
      :open="mvAddFamilyOpen"
      @close="panelClose('mvAddFamilyOpen')"
      @confirm="panelOpen('mvAddFamilyOpen')"
    />
  </main>
</template>

<script>
import UserDataTable from "../components/DataTable/DataTableScroll";
import DataTable from "../components/DataTable/DataTableCollapse";
import FixedBotton from "../components/modal/fixedBotton";
import { mapActions } from "vuex";
import { commonMixin } from "@/mixins/common";
import { queryPolicyList, queryPolicyRelateList } from "@/service";
import mvAddFamilyModal from "@/desktop/views/mv/components/mvAddFamilyModal";
import TruncateTool from "@/desktop/views/mv/PolicyInfo/components/TruncateTool";
import RouteToCustDetailMixins from "@/mixins/RouteToCustDetail";

export default {
  name: "RelationInfo",
  components: {
    UserDataTable,
    DataTable,
    FixedBotton,
    mvAddFamilyModal,
    TruncateTool,
  },
  mixins: [commonMixin, RouteToCustDetailMixins],
  data() {
    return {
      sendData: [], //勾選項目過濾
      mvAddFamilyOpen: false, // 歸戶Modal
      selection: [], // 勾選項目
      reqId: "", //當前ID
      reqName: "", //當前姓名
      remoteDataMsg: "資料讀取中，請稍候...", //讀取訊息
      userList: [], //保單關係人列表
      policyList: [], // 相關保單列表
      idList: [], //id列表
      checkTableTitle: true,
      tableOrder: {
        user: {
          order_by_default: "address", // 預設：住家地址
          order_asc_default: false, // 預設：大到小
          order_by: "address",
          order_asc: false,
        },
        policy: {
          order_by_default: "policy_no", // 預設：保單號碼
          order_asc_default: true, // 預設：小到大
          order_by: "policy_no",
          order_asc: true,
        },
      },
      tableOption: {
        user: {
          // 保單關係人table 參數
          isMoreCnt: 4, //顯示更多用:幾筆顯示更多，0為顯是全部
          moreLength: 4, //顯示更多用:資料長度
          checkAll: true,
          checkList: true,
          scrollHeight: 310,
          checkBoxHasUser: true,
          truncate: true,
          columns: [
            {
              width: 70,
              name: "name",
              label: "姓名",
              sorting: true,
              click: (data) => {
                this.routeToCustDetail2(data.id, data.ser_no, data.name);
              },
            },
            {
              width: 108,
              name: "mobile",
              label: "手機",
              sorting: true,
            },
            {
              width: 118,
              name: "phone",
              label: "電話",
              sorting: true,
            },
            {
              width: 90,
              name: "birthday",
              label: "生日",
              sorting: true,
            },
            {
              name: "address",
              sorting: true,
              label: "住家地址",
            },
            {
              width: 70,
              name: "family_name",
              sorting: true,
              label: "戶長",
              click: (data) => {
                this.routeToCustDetail(data.family_id, data.family_name);
              },
            },
          ],
          // 排序
          defaultSort: { colName: "address", asc: false, doSort: false },
          sorting: (orderby, colName, isSort) => {
            let policyRelationUsers = this.userList;
            this.userList = [];

            this.tableOrder.user.order_by = orderby;
            this.tableOrder.user.order_asc = isSort;

            if (
              colName === "name" ||
              colName === "address" ||
              colName === "family_name"
            ) {
              this.tableOrder.user.order_by = colName;
              this.queryPolicyRelate(
                this.$store.state.userInfo.id,
                this.idList
              );
            } else {
              policyRelationUsers.sort((itemA, itemB) => {
                let valueA = itemA[colName] || "";
                let valueB = itemB[colName] || "";

                if (valueA == valueB) {
                  return 0;
                }

                if (isSort) {
                  return valueA > valueB ? 1 : -1;
                } else {
                  return valueA > valueB ? -1 : 1;
                }
              });

              setTimeout(() => {
                this.userList = policyRelationUsers;
              }, 150);
            }
          },
          //顯示更多
          showMore: (boolean) => {
            this.tableOption.user.moreLength = boolean
              ? this.userList.length
              : this.tableOption.user.isMoreCnt;
          },
        },
        policy: {
          //相關保單table 參數
          color: "green",
          truncate: true,
          columns: [
            {
              customize: true,
              align: "right",
              width: 125,
              name: "policy_no",
              label: "保單號碼",
              sorting: true,
            },
            {
              width: 591,
              name: "prod_nm",
              label: "商品名稱",
              template: function (data) {
                let prod_id = data.prod_id;
                let html = "<span>" + data.prod_nm;
                if (prod_id) {
                  html += " (" + data.prod_id + ")";
                }
                html += "</span>";

                return html;
              },
            },
            {
              width: 124,
              name: "apc_name",
              label: "要保人",
              sorting: true,
              truncate_tool(data) {
                return data.apc_name;
              },
            },
            {
              width: 119,
              name: "insd_name",
              label: "被保人",
              sorting: true,
              truncate_tool(data) {
                return data.insd_name;
              },
            },
          ],
          defaultSort: { colName: "policy_no", asc: true, doSort: false },
          sorting: (colName, isSort) => {
            let policy = this.policyList;
            this.policyList = [];

            this.tableOrder.policy.order_by = colName;
            this.tableOrder.policy.order_asc = isSort;

            if (colName === "apc_name" || colName === "insd_name") {
              this.getRelationInfoList(
                this.$store.state.userInfo.id,
                this.reqId,
                true
              );
            } else {
              policy.sort((itemA, itemB) => {
                let valueA = itemA[colName] || "";
                let valueB = itemB[colName] || "";

                if (valueA == valueB) {
                  return 0;
                }

                if (isSort) {
                  return valueA > valueB ? 1 : -1;
                } else {
                  return valueA > valueB ? -1 : 1;
                }
              });

              setTimeout(() => {
                this.policyList = policy;
              }, 150);
            }
          },
        },
      },
    };
  },
  watch: {
    selection(selectedDatas) {
      this.sendData = selectedDatas;
      this.updateLastFamilyResult([]);
      this.updateFamilyResultFilter(selectedDatas);
    },
  },
  mounted() {
    this.reqId = this.$route.params.id;
    this.reqName = this.$route.params.name;

    if (this.reqId) {
      localStorage.reqId = this.reqId;
    } else {
      this.reqId = localStorage.reqId;
    }

    if (this.reqName) {
      localStorage.reqName = this.reqName;
    } else {
      this.reqName = localStorage.reqName;
    }

    this.doQuery();
  },
  methods: {
    ...mapActions([
      "updateCustID",
      "updateQueryKeyword",
      "updateSerNo",
      "updateFamilyResultFilter",
      "updateLastFamilyResult",
    ]),

    // 返回我要歸戶
    goBackJoinFamily() {
      this.$router.push({
        name: "joinFamily",
        query: this.$route.params.routeQuery,
      });
    },
    updateSelection(val) {
      this.selection = val;
    },
    updateSelectAll(val) {
      this.checkAll_f = val;

      if (val) {
        this.selection = this.userList.filter(
          (item) => !item.isShow && !item.family_id && (item.id || item.ser_no)
        );
      }
    },
    //查詢
    doQuery() {
      if (!this.$store.state.compositionStatus) {
        this.getRelationInfoList(this.$store.state.userInfo.id, this.reqId);
      }
    },

    // 送出
    sumbit() {
      this.setHistory("policyRelation", "addToFamily");

      //送出前整理資料格式
      this.sendData = this.sendData.map((item) => {
        if (!item.id || item.id === "") {
          item.csidno = item.ser_no;
        } else {
          item.csidno = item.id;
        }
        return item;
      });
      this.updateLastFamilyResult([]);
      this.updateFamilyResultFilter(this.sendData);
      this.panelOpen("mvAddFamilyOpen");
    },

    //取得相關保單資訊
    getRelationInfoList(userId, cust_id, sort = false) {
      queryPolicyList(
        userId,
        cust_id,
        this.tableOrder.policy.order_by,
        this.tableOrder.policy.order_asc === true ? "1" : "2"
      ).then((result) => {
        let mainIns = []; //主約
        let secondaryIns = []; //副約
        let id_list = []; // id列表
        result.body.rtnList.forEach((item) => {
          id_list.push(item.apc_id);
          id_list.push(item.insd_id);

          item.child = [];
          switch (
            item.prod_cat //
          ) {
            case "1": //主約
              mainIns.push(item);
              break;
            case "2": //副約
              secondaryIns.push(item);
              break;
            default:
              break;
          }
        });

        //去重複+null
        this.idList = id_list.filter(
          (item, index) => id_list.indexOf(item) === index && item
        );

        if (!sort) {
          this.queryPolicyRelate(this.$store.state.userInfo.id, this.idList);
        }

        //附約插到主約
        // 將各附約插入到保單號碼相同的主約
        secondaryIns.forEach((item1) => {
          mainIns.forEach((item2) => {
            if (item1.policy_no === item2.policy_no) {
              item2.child.push(item1);
            }
          });
        });

        // 排序各附約 prod_id 順序
        mainIns.forEach((item) => {
          if (item.child.length > 0) {
            item.child.sort((a, b) => {
              return a.prod_id > b.prod_id ? 1 : -1;
            });
          }
        });

        // 取出沒有主約的附約保單
        let mainInsNo = mainIns.map((item) => item.no);
        let onlySub = secondaryIns
          .filter((item) => {
            let custID = this.$store.state.custInfo.ID;
            // 取出附約需判斷要保人或被保人要是該位客戶
            return (
              !mainInsNo.includes(item.no) &&
              (item.clientId == custID || item.target_id == custID)
            );
          })
          .map((item) => {
            return {
              ...item,
              onlySubIns: true,
            };
          });
        mainIns = [...mainIns, ...onlySub];

        this.policyList = mainIns;
      });
    },

    //查詢保單關係人資訊
    queryPolicyRelate(userId, data) {
      this.remoteDataMsg = "資料讀取中，請稍候...";
      queryPolicyRelateList(
        userId,
        data,
        this.tableOrder.user.order_by,
        this.tableOrder.user.order_asc === true ? "1" : "2"
      ).then((result) => {
        if (result.header && result.header.status == "400") {
          this.$toast.info({ title: result.header.message });
        }

        this.userList = result.body.rtnList || [];
        if (!this.userList.length) {
          this.remoteDataMsg = "查無資料";
        }
        this.userList.forEach((x) => {
          x.phone = [x.home_tel_area, x.home_tel].filter((x) => x).join("-");
          x.address = [
            x.home_addr_zip,
            x.home_addr1,
            x.home_addr2,
            x.home_addr3,
          ]
            .filter((x) => x)
            .join("");
        });
      });
    },
    // 導到個人資訊
    routeToCustDetail(id, { custId = "", serNo = "" }) {
      if (custId !== "") {
        this.updateCustID(custId);
        this.updateSerNo("");
        localStorage.CustID = custId;
        localStorage.SerNo = "";
        this.$router.push({ path: `/detail/CustID/tab/1` });
      } else {
        this.updateSerNo(serNo);
        this.updateCustID("");
        localStorage.CustID = "";
        localStorage.SerNo = serNo;
        this.$router.push({ path: `/detail/SerNo/tab/1` });
      }
    },
  },
};
</script>
<style scoped>
.bottom_btn_style {
  width: 120px;
  height: 40px;
}
</style>
